import { JSX } from "react";
import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from "@mui/material";

type Option = {
  show: boolean,
  onClick?: (e?: React.MouseEvent) => void,
  icon?: JSX.Element,
  title: string,
  disabled?: boolean,
}

export default function InlineMenu(props: {
  title: string | JSX.Element,
  options: Option[]
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="w3-margin-top w3-margin-bottom">
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {props.title}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {
          props.options.filter(i => i.show).map((i, index) => {
            return <MenuItem
              key={`${props.title}-${index}-${i.title}`}
              onClick={i.onClick}
              disabled={!!i.disabled}
            >
              <ListItemIcon>
                {i.icon}
              </ListItemIcon>
              <ListItemText>
                {i.title}
              </ListItemText>
            </MenuItem>
          })
        }
      </Menu>
    </div>
  );
}